<template>
  <v-expansion-panels :value="expansionPanelValue">
    <v-expansion-panel>
      <v-expansion-panel-header>
        <template v-slot:default="{ open }">
          <v-row no-gutters>
            <v-col cols="12">
              <v-fade-transition leave-absolute>
                <span v-if="!open" key="0">
                  <slot name="closed-header" />
                </span>
                <span v-else key="1">
                  <slot name="opened-header" />
                </span>
              </v-fade-transition>
            </v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <RiskAnalysisForm
          ref="analysisForm"
          :value="value"
          :timeZone="timeZone"
          :onlyDates="onlyDates"
          :nameRules="nameRules"
          :readonly="readonly"
          @input="$emit('input', $event)"
        ></RiskAnalysisForm>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import RiskAnalysisForm from './RiskAnalysisForm'

export default {
  name: 'RiskAnalysisPanel',
  components: {
    RiskAnalysisForm
  },
  props: {
    value: {
      type: Object,
      description: 'Risk Analysis'
    },
    timeZone: {
      type: String,
      description: 'Time zone to represent times in. Should be set to utc for standalone ARA.',
      default: 'local'
    },
    onlyDates: {
      type: Boolean,
      description: 'Drop the time component from the start and end dates',
      default: false
    },
    readonly: Boolean,
    opened: Boolean,
    nameRules: Array
  },
  computed: {
    expansionPanelValue() {
      return this.opened ? 0 : undefined
    }
  },
  methods: {
    validate() {
      return this.$refs.analysisForm ? this.$refs.analysisForm.validate() : true
    },
    resetValidation() {
      return this.$refs.analysisForm ? this.$refs.analysisForm.resetValidation() : true
    }
  }
}
</script>
